import {  ADD_NEW_USER_SUCCESS, UPDATE_NEW_USER_SUCCESS, USER_DATA_ERROR,  USER_DATA_SUCCESS, ALL_USER_DATA_SUCCESS, GET_USER_DEVICES_SUCCESS, GET_USER_DEVICES_ERROR, SET_PRIMARY_DEVICE_SUCCESS } from "./actiontype"


const initialState = {
  newUser:null,
  updateUser:null,
  userDevices:null

}

const getuserData = (state = initialState, action) => {
  switch (action.type) {
    case USER_DATA_SUCCESS:
      state = {
        ...state,
        userlist: action.payload,
        userlistError: null,
      }
      break

    case ALL_USER_DATA_SUCCESS:
      state = {
        ...state,
        alluserslist: action.payload,
        userlistError: null,
      }
      break

    case USER_DATA_ERROR:
      state = { ...state, userlistError: action.payload }
      break
    case ADD_NEW_USER_SUCCESS:
      state = { ...state, newUser: action.payload }
      break
    case UPDATE_NEW_USER_SUCCESS:
      state = { ...state, updateUser: action.payload }
      break
    case GET_USER_DEVICES_SUCCESS:
      state = { ...state, userDevices: action.payload }
      break
    case GET_USER_DEVICES_ERROR:
      state = { ...state, userDevices: null }
      break
    case SET_PRIMARY_DEVICE_SUCCESS:
      state = { ...state, primaryDeviceUpdate: action.payload }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default getuserData
